import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";

export default function BrokerCallback() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("processing"); // processing | ok | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const requestToken = searchParams.get("request_token");
    const action = searchParams.get("action");

    if (!requestToken || action !== "login") {
      setStatus("error");
      setMessage("Missing request_token or action in URL.");
      return;
    }

    (async () => {
      try {
        // Exchange request_token using saved api_key + api_secret (__saved__ sentinel).
        await api.post("/brokers/zerodha/connect", {
          credentials: {
            api_key: "__saved__",
            api_secret: "__saved__",
            request_token: requestToken,
          },
        });
        // Run live test to flip status to 'live'.
        await api.post("/brokers/zerodha/test");
        setStatus("ok");
        setMessage("Zerodha linked successfully. You can close this tab.");
        setTimeout(() => window.close(), 3000);
      } catch (e) {
        const detail = e?.response?.data?.detail || String(e);
        setStatus("error");
        setMessage(detail);
      }
    })();
  }, []);

  const color = status === "ok" ? "#10b981" : status === "error" ? "#ef4444" : "#f59e0b";
  const label =
    status === "ok" ? "BROKER LINK OK" :
    status === "error" ? "BROKER LINK FAILED" :
    "LINKING…";

  return (
    <div style={{
      background: "#0a0a0a", color: "#fff", minHeight: "100vh",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: "'IBM Plex Sans', system-ui",
    }}>
      <div style={{
        textAlign: "center", padding: 40, border: "1px solid #27272a", maxWidth: 520,
      }}>
        <div>
          <span style={{
            width: 10, height: 10, background: color,
            display: "inline-block", borderRadius: "50%", marginRight: 10,
          }} />
          ALGOFORGE — {label}
        </div>
        {message && (
          <div style={{
            fontFamily: "'JetBrains Mono', monospace", fontSize: 13,
            color: "#a1a1aa", marginTop: 14, wordBreak: "break-word",
          }}>
            {message}
          </div>
        )}
        {status === "ok" && (
          <div style={{ color: "#52525b", marginTop: 18, fontSize: 13 }}>
            Closing automatically…
          </div>
        )}
      </div>
    </div>
  );
}
